import { ProductTypeListProps } from "./ProductTypeList.componentModel";
import { useComponentData } from "./ProductTypeList.componentService";
import { ProductTypeListView } from "./ProductTypeList.componentView";

const ProductTypeList = (props: ProductTypeListProps) => {
  const { componentData } = useComponentData(props);
  return <ProductTypeListView componentData={componentData} />;
};
export { ProductTypeList, type ProductTypeListProps };
